import React, { useEffect, useState } from 'react'
import { getMedications } from '../../api/medicationsApi';
import { fetchRecommendations } from '../../api/recommendationApi';
import { generateHealthSummary } from '../../utils/generateSummary';
import { getMedicalConditions } from '../../api/medicalConditionApi';
import { getSurgeries } from '../../api/surgeryApi';

export default function HealthSummary({userId}) {
    const [summary, setSummary] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
          const medicalConditions = await getMedicalConditions(userId);
          const surgeries = await getSurgeries(userId);
          const meds = await getMedications(userId);
          const recommendations = await fetchRecommendations();
          const summaryMsgs = generateHealthSummary(medicalConditions, surgeries, meds, recommendations)

          setSummary(summaryMsgs);
        }
    
        fetchData();
      }, [userId])

    return (
        <section>
          <h2 className="text-2xl font-bold my-4 text-[#04395b]">Weekly Health Summary</h2>
          <h1 className="text-xl text-black mb-2">Based on your profile:</h1>
          {summary.length > 0 ? (
            <ul className="list-disc list-inside space-y-2 text-gray-700 mb-3">
              {summary.map((msg, idx) => (
                <li key={idx}>{msg}</li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-600 italic mb-3">No recommendations at this time.</p>
          )}
        </section>
    )
}